import { createContext } from 'react';
import { QUERY_KEYS_OBJECTS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const ObjectsChartsDataContext = createContext();

const ObjectsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_BRAND,
            url: 'governanceroom/securitydashboard/objects/brand'
        },
        filterParams
    );

    const typeEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_TYPE,
            url: 'governanceroom/securitydashboard/objects/types'
        },
        filterParams
    );

    const subtypeEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_SUBTYPE,
            url: 'governanceroom/securitydashboard/objects/subtypes'
        },
        filterParams
    );

    const blockStatusEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_BLOCKSTATUS,
            url: 'governanceroom/securitydashboard/objects/blockStatus'
        },
        filterParams
    );

    const quantityEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_QUANTITY,
            url: 'governanceroom/securitydashboard/objects/quantity'
        },
        filterParams
    );

    const chartData = {
            brandAnual: data?.anualEvolution || [],
            brandMonth: data?.monthEvolution || [],
            typeAnual: typeEvolutionData.data?.anualEvolution || [],
            typeMonth: typeEvolutionData.data?.monthEvolution || [],
            subtypeAnual: subtypeEvolutionData.data?.anualEvolution || [],
            subtypeMonth: subtypeEvolutionData.data?.monthEvolution || [],
            blockStatusAnual: blockStatusEvolutionData.data?.anualEvolution || [],
            blockStatusMonth: blockStatusEvolutionData.data?.monthEvolution || [],
            quantityAnual: quantityEvolutionData.data?.anualEvolution || [],
            quantityMonth: quantityEvolutionData.data?.monthEvolution || []
          }

    return (
        <ObjectsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ObjectsChartsDataContext.Provider>
    );
};

export default ObjectsChartsDataProvider;
